import * as React from 'react';

function SvgTransactionsIcon(props) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.25 11H16.5V2.75a.917.917 0 00-1.375-.797l-2.75 1.576-2.75-1.576a.917.917 0 00-.916 0l-2.75 1.576-2.75-1.576a.917.917 0 00-1.376.797v14.667a2.75 2.75 0 002.75 2.75h12.834a2.75 2.75 0 002.75-2.75v-5.5A.917.917 0 0019.25 11zM4.584 18.333a.917.917 0 01-.917-.916V4.336L5.5 5.38a.99.99 0 00.917 0l2.75-1.577 2.75 1.577a.99.99 0 00.917 0l1.833-1.045v13.08c.002.313.058.623.165.917H4.583zm13.75-.916a.917.917 0 01-1.834 0v-4.584h1.834v4.584z"
        fill="#748CAD"
      />
      <path
        d="M6.994 14.447v-2.46h-.577v-.738h.577v-.717h-.577v-.738h.577v-2.46H8.56l.777 2.46h.907v-2.46h1.106v2.46h.567v.738h-.567v.717h.567v.737h-.567v2.461H9.774l-.797-2.46H8.1v2.46H6.994zm1.067-4.653h.279l-.29-.956h-.04l.05.956zm.04 1.455h.657l-.22-.717H8.08l.02.717zm1.703 0h.458l-.02-.717h-.667l.23.717zm.469 1.644h.05l-.04-.907h-.27l.26.907z"
        fill="#748CAD"
      />
    </svg>
  );
}

export default SvgTransactionsIcon;
